<template>
  <teleport to="body">
    <div v-if="open" class="share-preview-modal-overlay" @click.self="close">
      <div class="share-preview-modal" :class="{ 'is-pdf': type === 'pdf' }">
        <div class="share-preview-modal-header">
          <div class="share-preview-modal-title" :title="title">{{ title }}</div>
          <button
            type="button"
            class="share-preview-modal-close"
            aria-label="閉じる"
            @click="close"
          >&times;</button>
        </div>
        <div class="share-preview-modal-body">
          <videojs
            v-if="type === 'video'"
            :key="src"
            :src="src"
            :poster="poster"
            :start-timecode="startTimecode"
            :frame-rate="frameRate"
          ></videojs>
          <pdf-preview-pdfjs
            v-else-if="type === 'pdf'"
            :key="src"
            :src="src"
            height="75vh"
          ></pdf-preview-pdfjs>
          <cad-viewer-aps
            v-else-if="type === 'cad'"
            :key="src"
            :src="src"
            :share-token="shareToken"
          ></cad-viewer-aps>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
// バンドル共有ページの「プレビュー」ボタンから share-preview:open イベントを受けて
// 動画 / PDF をモーダル表示する。plain-JS（share-bundle.js）との橋渡しは CustomEvent。
export default {
  data() {
    return {
      open: false,
      type: null,
      src: '',
      poster: '',
      title: '',
      shareToken: '',
      startTimecode: null,
      frameRate: null,
    };
  },
  methods: {
    handleOpen(event) {
      const detail = event.detail || {};
      if (!detail.type || !detail.src) {
        return;
      }
      this.type = detail.type;
      this.src = detail.src;
      this.poster = detail.poster || '';
      this.title = detail.name || '';
      this.shareToken = detail.shareToken || '';
      this.startTimecode = detail.startTimecode || null;
      this.frameRate = detail.frameRate || null;
      this.open = true;
      document.body.style.overflow = 'hidden';
    },
    close() {
      this.open = false;
      this.type = null;
      this.src = '';
      this.poster = '';
      this.title = '';
      this.shareToken = '';
      this.startTimecode = null;
      this.frameRate = null;
      document.body.style.overflow = '';
    },
    handleKeydown(event) {
      if (event.key === 'Escape' && this.open) {
        this.close();
      }
    },
  },
  mounted() {
    document.addEventListener('share-preview:open', this.handleOpen);
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('share-preview:open', this.handleOpen);
    document.removeEventListener('keydown', this.handleKeydown);
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>
.share-preview-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20000;
  padding: 24px;
}

.share-preview-modal {
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.share-preview-modal.is-pdf {
  max-width: 720px;
}

.share-preview-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 18px;
  border-bottom: 1px solid #e6e6e6;
}

.share-preview-modal-title {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.share-preview-modal-close {
  font-size: 24px;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 1;
  color: #666;
  margin-left: 12px;
}

.share-preview-modal-body {
  padding: 18px;
  overflow-y: auto;
  flex: 1;
}

/* ダークモードの上書きは resources/sass/exa/_dashboard-dark.scss に定義（coding.md 準拠） */
</style>
